import React from 'react';

import * as classes from './Header.module.css';

const header = (props) => {
  return (
    <header className={classes.Header}>
      <p>
        TO-DO List
      </p>
    </header>
  )
}

export default header;
